module.exports = __webpack_public_path__ + "static/media/on-eye_fresh-Lilac.9b82ca30.jpg";